// extracted by mini-css-extract-plugin
export default {"analytics":"Analytics_analytics__DTmUP","control":"Analytics_control__MdUch","spacer":"Analytics_spacer__ksYv6","canvas":"Analytics_canvas__4aAqG","loader":"Analytics_loader__b15uM"};